var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-store-availability-states.j2"] = require( "product-store-availability-states.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-store-availability.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-product-store-availability\">\n    ";
output += "\n    <div class=\"o-row\">\n\n        <div class=\"o-column o-extra-small--12\">\n            <a href=\"#product_store-availability__panel\" id=\"product_store-availability__tab\" class=\"o-accordion__tab c-product-details__tab js-accordion-tab\" aria-selected=\"true\" aria-controls=\"product_store-availability__panel\" aria-expanded=\"false\" role=\"tab\" data-accordion-title=\"store availability\">\n\n                <h3 class=\"o-accordion__label c-product-details__label\">\n                    ";
output += runtime.suppressValue((lineno = 8, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_store_availability",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </h3>\n\n                <span class=\"o-accordion__control c-product-details__collapse\" title=\"collapse\"></span>\n\n            </a>\n\n        </div>\n\n    </div>\n\n    ";
output += "\n    <div id=\"product_store-availability__panel\" class=\"o-accordion__panel js-accordion-panel c-product-details__section c-product-details__section--availability\" aria-labelledby=\"product_contents__tab\" aria-hidden=\"false\" role=\"tabpanel\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">";
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"defaultStore");
frame.set("defaultStore", t_1, true);
if(frame.topLevel) {
context.setVariable("defaultStore", t_1);
}
if(frame.topLevel) {
context.addExport("defaultStore", t_1);
}
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"selectedSku")),"sku");
frame.set("selectedSku", t_2, true);
if(frame.topLevel) {
context.setVariable("selectedSku", t_2);
}
if(frame.topLevel) {
context.addExport("selectedSku", t_2);
}
var t_3;
t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"selectedPool");
frame.set("selectedPool", t_3, true);
if(frame.topLevel) {
context.setVariable("selectedPool", t_3);
}
if(frame.topLevel) {
context.addExport("selectedPool", t_3);
}
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"lowStockThreshold") || 5;
frame.set("lowStockThreshold", t_4, true);
if(frame.topLevel) {
context.setVariable("lowStockThreshold", t_4);
}
if(frame.topLevel) {
context.addExport("lowStockThreshold", t_4);
}
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"noStoreMessage");
frame.set("noStoreMessage", t_5, true);
if(frame.topLevel) {
context.setVariable("noStoreMessage", t_5);
}
if(frame.topLevel) {
context.addExport("noStoreMessage", t_5);
}
var t_6;
t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"bopisCallHasBeenMade");
frame.set("bopisCallHasBeenMade", t_6, true);
if(frame.topLevel) {
context.setVariable("bopisCallHasBeenMade", t_6);
}
if(frame.topLevel) {
context.addExport("bopisCallHasBeenMade", t_6);
}
var t_7;
t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productBopis")),"stock");
frame.set("stock", t_7, true);
if(frame.topLevel) {
context.setVariable("stock", t_7);
}
if(frame.topLevel) {
context.addExport("stock", t_7);
}
env.getTemplate("product-store-availability-states.j2", false, "product/templates/product-store-availability.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-store-availability.j2"] , dependencies)